var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8001\\u8BB8-\\u5B9E\\u65F6\\u76D1\\u63A7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1007461-\\u5B9E\\u65F6\\u76D1\\u63A7-\\u8BA1\\u91CF\\u7535\\u8868",
    transform: "translate(-78.000000, -1191.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.\\u5178\\u578B\\u9875\\u9762/3.\\u6811\\u5F62\\u7ED3\\u6784\\u9875\\u9762/\\u5C55\\u5F00",
    transform: "translate(-0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-energy",
    transform: "translate(79.000000, 1191.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,14 C1.22385763,14 1,13.7761424 1,13.5 L1,2.5 C1,2.22385763 1.22385763,2 1.5,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,13.5 C15,13.7761424 14.7761424,14 14.5,14 L1.5,14 Z M3,3 L2,3 L2,13 L3,13 L3,3 Z M12,3 L4,3 L4,13 L12,13 L12,3 Z M14,3 L13,3 L13,13 L14,13 L14,3 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fillOpacity: 0.65,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-\\u5145\\u7535\\u7AD9\\u5907\\u4EFD-2",
    transform: "translate(5.500000, 5.000000)",
    fill: "#F7B500",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.94188953,1.90088418 L3.338746,1.90088418 L4.78033808,0.0938529977 C4.81017416,0.0555898525 4.78324891,0 4.73449239,0 L1.94372731,0 C1.92335145,0 1.9037033,0.010829192 1.89351537,0.0288778454 L0.00802063259,3.2595868 C-0.014538355,3.29784995 0.0131145975,3.34622034 0.0582325728,3.34622034 L1.32735755,3.34622034 L0.676785459,5.92789972 C0.662958982,5.98421152 0.731363655,6.02391856 0.773570793,5.98348958 L4.98191355,1.9997908 C5.01975443,1.96441544 4.9942846,1.90088418 4.94188953,1.90088418 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsa);
export default __webpack_public_path__ + "static/media/bsa.35fa1f158353a8128d728cbef9bcae16.svg";
export { ForwardRef as ReactComponent };